import { SET_SELECTED_PROPERTIES } from '../constants';

export const actionSetSelectedProperties = ({ propertiesToSelect }) => {
  return async dispatch => {
    dispatch({ type: SET_SELECTED_PROPERTIES, propertiesToSelect });
  };
};

export default actionSetSelectedProperties;
